export const skillAssessmentAnswerOptions = [
  { id: 1, name: "Yes / No" },
  { id: 2, name: "Master" },
  { id: 3, name: "Experience Level" },
];
